/**
 * @generated SignedSource<<05678062d963c1ba5e27fa28b5664aa5>>
 * @relayHash 7307bf97b72fe4cecff0850d3f9c1cdf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 63609dcce8179515d7981b0480b3618f24b5f3eda4105e87951dba861a3f6380

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "63609dcce8179515d7981b0480b3618f24b5f3eda4105e87951dba861a3f6380",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
